import React, { useState } from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';

const DataTableItmExtra = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage, handleEditOpen, deleteRecord }) => {
    return (
        <TableWrapServerSide tableColumnList={tableColumn} totalDataCount={totalRecord} initialPage={dataFilter?.page} onChangePage={onChangePage} per_page={dataFilter?.limit}>
            {dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data.name}</td>
                        <td className="db-table-body-td">{data.price}</td>
                        <td className="db-table-body-td">{data.status && data.status == '1' ? <span className={'active'}>Active</span> : <span className={'inactive'}>Inactive</span>}</td>
                        <td className="db-table-body-td hidden-print hidden-print-remove">
                            <div className="flex justify-start items-center sm:items-start sm:justify-start gap-1.5">
                                <button data-modal="#sidebar" className="db-table-action edit" onClick={() => handleEditOpen(data._id)}>
                                    <i className="lab lab-edit-line"></i>
                                    <span className="db-tooltip">edit</span>
                                </button>
                                <button className="db-table-action delete" onClick={() => deleteRecord(data._id)}>
                                    <i className="lab lab-delete"></i>
                                    <span className="db-tooltip">delete</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTableItmExtra;
